import {Injectable, signal} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class UiService {
    readonly loading = signal(false);
    readonly theme = signal(environment.production ? 'light-theme' : 'dark-theme');
    readonly production = environment.production;

    constructor() {
    }

    public loadingHandler = () => (source: Observable<any>) => {
        return new Observable((observer) => {
            this.loading.set(true);
            source.subscribe((val) => {
                observer.next(val);
            }, (err) => {
                this.loading.set(false);
                observer.error(err);
            }, () => {
                this.loading.set(false);
                observer.complete();
            });
        });
    };

    public toggleTheme() {
        const dark = this.theme() === 'dark-theme';
        this.theme.set(dark ? 'light-theme' : 'dark-theme');
    }

}
